<template>
  <div class="uploadImage">
    <div
      class="content-item flex align-items-center"
      :class="{ loaded: uploadSuccess }"
    >
      <el-upload
        action="/imageUpload.action"
        :auto-upload="false"
        list-type="picture-card"
        :on-remove="onImgRemove"
        :on-preview="onImgPreview"
        :http-request="httpRequest"
        :on-change="onImgChange"
        :before-upload="checkFile"
        :limit="1"
        :file-list="titlePicUrl"
        accept=".jpg,.jpeg,.png"
        ref="fileUpload"
        :fixed="true"
        :fixedNumber="[10, 10]"
      >
        <div
          class="item-conver flex align-items-center justify-content-center flex-direction-column"
        >
          <img src="~_img/upload.png" alt="图片上传" />
          <span>上传图片</span>
        </div>
      </el-upload>
      <p class="tips">图片尺寸不低于100x100</p>
    </div>

    <!-- 图片预览 -->
    <!-- <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog> -->

    <modal :isShow.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </modal>
    <!-- vueCropper 剪裁图片实现-->
    <modal
      :isShow.sync="dialogCropperVisible"
      :title="dialogTitles"
      :btnText="btnText"
      :isShowBtn="isShowBtn"
      :width="dialogWidth"
      @clickHandler="clickHandler"
      @update:isShow="closeDialog"
      class="cropper-dialog"
    >
      <div v-if="nocrop">
        <img :src="cropperImg" alt="" />
      </div>
      <div v-else class="cropper-content">
        <!-- <div class="cropper-content"> -->
        <div class="cropper" style="text-align: center">
          <vueCropper
            ref="cropper"
            :img="cropperImg"
            :outputSize="0.8"
            outputType="jpeg"
            :info="true"
            :full="true"
            :canScale="true"
            :canMoveBox="true"
            :original="false"
            :autoCrop="true"
            :fixedNumber="[10, 10]"
            :centerBox="true"
            :infoTrue="false"
            :fixedBox="false"
            :autoCropWidth="100"
            :autoCropHeight="100"
            :fixed="true"
            mode="cover"
          ></vueCropper>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import modal from "@/components/modal";
import { uploadFile } from "@/utils/axios";
const imgHost = process.env.VUE_APP_imgHost;
export default {
  name: "uploadImgUniversal",
  props: ["data", "required", "nocrop"],
  data() {
    return {
      user_identity: 0, // 身份信息
      uploadSuccess: false,
      titlePicUrl: [],
      dialogVisible: false,
      dialogImageUrl: "",
      dialogCropperVisible: false,
      cropperImg: "",
      imgHost: imgHost,
      dialogTitles: "图片裁剪",
      btnText: ["取消", "确认"],
      dialogWidth: "480px",
      isShowBtn: [true, true],
      nocrop: false,
    };
  },
  components: {
    modal,
  },
  watch: {
    titlePicUrl(val) {
      this.$emit("change-title-pic", val);
    },
    data(value) {
      if (value) {
        this.titlePicUrl = []; // 清空封面图
        this.titlePicUrl.push({
          url: this.imgHost + this.data,
        });
        this.uploadSuccess = true;
      } else {
        this.titlePicUrl = [];
        this.uploadSuccess = false;
      }
    },
    nocrop(value) {
      this.nocrop = true;
    },
  },
  created() {
    const imgHost = process.env.VUE_APP_imgHost;
    console.log(this.imgHost);
  },
  mounted() {
    this.init();
  },
  methods: {
    clickHandler(val) {
      if (val == "one") {
        this.cancel();
      }
      if (val == "two") {
        if (this.nocrop) {
          this.dialogCropperVisible = false;
          console.log("==== this.cropperImg", this.cropperImg);
          this.file = this.cropperImg;
          this.$refs.fileUpload.submit();
          console.log("==== onImgChnage crop", this.titlePicUrl);
        } else {
          this.finish();
          console.log("==== onImgChnage nocrop", this.titlePicUrl);
        }
        // this.finish();
        console.log("==== onImgChnage both", this.titlePicUrl);
      }
    },
    closeDialog() {
      this.titlePicUrl = [];
    },
    init() {
      //(type: 1：文章标签 4：疾病)
      //(type:  4：疾病)
      // this.queryLabels(4);
      // this.queryLabels(1);

      this.user_identity = sessionStorage.getItem("user_identity");
    },
    onImgRemove(file, fileList) {
      this.titlePicUrl = fileList;
      this.uploadSuccess = false;
    },
    onImgChange(file, fileList) {
      // image/png, image/jpeg,image/gif
      // this.form.titlePicUrl= fileList
      if (
        ["image/png", "image/jpeg", "image/gif"].indexOf(file.raw.type) == -1
      ) {
        this.$message.error("文件格式不正确！");
        this.titlePicUrl = []; // 清空封面图
        return false;
      }
      if (!this.nocrop) {
        this.cropperImg = file.url;
        this.dialogCropperVisible = true;
      } else {
        fetch(file.url)
          .then((response) => response.blob())
          .then((blob) => {
            console.log("======blob", blob);
            this.file = blob;
            this.$refs.fileUpload.submit();
          })
          .catch((error) => {
            console.error("Error converting file URL to Blob:", error);
          });
      }
    },
    onImgPreview(file) {
      console.log("==== onpreView", file);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    checkFile(file) {
      const isJPG = /image\/(jpeg|png)/.test(file.type);
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error("上传图片只能是jpg、png格式！");
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      let data = window.URL.createObjectURL(new Blob([file]));
      this.fileName = file.name;
      return isJPG && isLt5M;
    },
    httpRequest(request) {
      let file = this.file;
      this.uploadFile(file, (msg) => {
        this.titlePicUrl = [
          {
            url: this.imgHost + msg,
          },
        ];
      });
    },
    uploadFile(file, callback) {
      console.log("====== here", file);
      uploadFile(file, (event) => {
        let percent = parseInt((event.loaded / event.total) * 100 + "");
        if (percent > 99) {
          percent = 99;
        }
        file.progress = percent;
        file.status = "pending";
        // this.setStoragePropertyByName(storageProperty, uploadImageList);
      })
        .then((res) => {
          const id = res.data[0]["id"];
          if (id === "1") {
            const url = res.data[0]["msg"];
            callback && callback(url);
            file.status = "resolve"; // 是否上传成功，根据是否有url来判断
            this.uploadSuccess = true;
          } else if (id === "0") {
            this.$message.error("图片上传失败");
          }
        })
        .catch((error) => {
          file.status = "reject";
          this.$message.error("图片上传失败");
        });
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish() {
      this.dialogCropperVisible = false;
      this.$refs.cropper.getCropBlob((data) => {
        this.file = data;
        this.$refs.fileUpload.submit();
      });
    },
    cancel() {
      this.dialogCropperVisible = false;
      this.titlePicUrl = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.uploadImage {
  :deep(.el-upload--picture-card) {
    background-color: transparent;
    border: none;
    line-height: normal;
  }

  :deep(.el-upload-list__item) {
    width: 150px !important;
    height: 150px !important;
    border: 1px solid rgba(0, 0, 0, 0.15) !important;
    border-radius: 50%;
  }

  :deep(.el-upload-list__item-status-label) {
    display: none !important;
  }
  .cropper-dialog {
    .el-dialog {
      width: 450px;
    }

    .cropper-content {
      width: 100%;
      padding: 20px;

      .cropper {
        width: 100%;
        height: 300px;
      }
    }
  }
  .item-conver {
    width: 150px;
    height: 150px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    font-size: 12px;
    color: #989ca5;

    img {
      margin-bottom: 8px;
    }
  }
  .tips {
    margin-left: 15%;
    color: #989ca5;
  }
}
</style>
